'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nRenderLines = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
                                                                                                                                                                                                     * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * This document is the property of Nettoken Ltd.
                                                                                                                                                                                                     * It is considered confidential and proprietary.
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * This document may not be reproduced or transmitted in any form,
                                                                                                                                                                                                     * in whole or in part, without the express written permission of
                                                                                                                                                                                                     * Nettoken Ltd.
                                                                                                                                                                                                     */


/*
 * @param {Array} text
 */
var i18nRenderLines = exports.i18nRenderLines = function i18nRenderLines(text) {
  if (!Array.isArray(text)) return text;

  var withBreaks = [];
  text.forEach(function (line, index) {
    withBreaks = [].concat(_toConsumableArray(withBreaks), [line, _react2.default.createElement('br', { key: index })]);
  });
  return withBreaks;
};

exports.default = i18nRenderLines;